export const LIST_TEACHER = 'LIST_TEACHER';
export const LIST_COURSE = 'LIST_COURSE';
export const CREATE_LINK_PAYMENT = 'CREATE_LINK_PAYMENT';
export const GET_STUDENT_DETAIL = 'GET_STUDENT_DETAIL';
export const RESET_STUDENT_DETAIL = 'RESET_STUDENT_DETAIL';